export { default as EyeIcon } from './component';
